import { render } from "./TheHeader.vue?vue&type=template&id=33c67e4e&ts=true"
import script from "./TheHeader.vue?vue&type=script&lang=ts"
export * from "./TheHeader.vue?vue&type=script&lang=ts"

import "./TheHeader.vue?vue&type=style&index=0&id=33c67e4e&lang=css"

import exportComponent from "D:\\onepack\\hotaru_theme-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__